import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

// Styled Components
const Error = styled.div`
  background-color: #f7dbdb;
  color: #660014;
  display: inline-block;
  margin-bottom: 40px;
  padding: 12px 16px;
  position: relative;
  width: 100%;

  a {
    color: #660014;
  }
`;

const ErrorLabel = styled.strong`
  margin-right: 4px;
`;

const ErrorText = styled.span`
  margin-right: 4px;
`;

const FormError = ({ message, errorLabel = null, children }) => (
  <Error>
    <ErrorLabel>{errorLabel || 'Error:'}</ErrorLabel>
    <ErrorText>{message}</ErrorText>
    {children}
  </Error>
);

export default FormError;

FormError.propTypes = {
  /* HTML: The primary error text */
  message: PropTypes.string,
  /* HTML: The primary error label text */
  errorLabel: PropTypes.string,
  /* HTML: Optional child elements to render after, or in place of, the message */
  children: PropTypes.node,
};
